/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents an object to wrap a sent email.
 */
export interface SentEmailModel { 
    logId: number;
    recipientEmail: string;
    senderEmail: string;
    sentAtUtc: string;
    subject: string;
}

